import { render, staticRenderFns } from "./Dialogs_ReturnConfirm.vue?vue&type=template&id=2580722a&"
import script from "./Dialogs_ReturnConfirm.vue?vue&type=script&lang=js&"
export * from "./Dialogs_ReturnConfirm.vue?vue&type=script&lang=js&"
import style0 from "./Dialogs_ReturnConfirm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports